import { useEffect } from 'react';

const usePreventPageScroll = (isOpen) => {
    useEffect(() => {
        if (!isOpen)
            return;
        const html = document.querySelector('html');
        const body = document.querySelector('body');
        /* istanbul ignore next */
        if (!html || !body)
            return;
        const isScrollable = body.scrollHeight > body.clientHeight;
        if (!isScrollable)
            return;
        html.classList.add('dynamic-no-scroll');
        body.classList.add('dynamic-no-scroll');
        return () => {
            html.classList.remove('dynamic-no-scroll');
            body.classList.remove('dynamic-no-scroll');
        };
    }, [isOpen]);
};

export { usePreventPageScroll };
